(ns ui.security.sanitize
  (:require [goog.html.sanitizer.HtmlSanitizer :as Sanitizer]))


(def globals (atom {}))

(defn get-sanitizer
  ([]
   (get-sanitizer :html))
  ([sanitizer-type]
   (or (get @globals sanitizer-type)
       (when-let [sanitizer (js/Sanitizer.)]
         (swap! globals assoc sanitizer-type sanitizer)
         sanitizer))))

(defn sanitize-url
  [txt]
  (let [res (if-let [sanitizer (get-sanitizer)]
              (if (aget sanitizer "sanitizeUrl")
                (.call (aget sanitizer "sanitizeUrl") sanitizer txt)
                (.call (aget sanitizer "sanitize") sanitizer txt))
              txt)]
    #_(when-not (= res txt)
        (logging/warn "Sanitized url " txt " ->> " res))
    res))
